import { uniqueKey } from 'global/common/keys';
import React, { useMemo } from 'react'
import { gameScoringTypes } from '../../cnr/reducers/SportsSeasonReducer';

export const SectionHeaders = ({ gameScoringType, tableType, isNonSection, gameAllowTies }) => {

  const standingsHeader = useMemo(() => {
    let cn = 'standing-section-header'
    let hdrs1;
    if (isNonSection) {
      hdrs1 = ['P', '#', 'team', 'SW', 'SL']
    } else {
      if (tableType === 'normal') {
        hdrs1 = ['team', 'section', 'nonSection', 'w', 'l', 'w', 'l']
      } else {
        switch (gameScoringType) {
          case gameScoringTypes.match:
            hdrs1 = ['section', 'overall', 'team', 'w', 'l', 'ow', 'ol']
            break;
          case gameScoringTypes.matchPoints:
            hdrs1 = ['section', 'overall', 'team', 'w', 'l', 'p', 'ow', 'ol', 'op']
            cn += ' pts'
            break;
          case gameScoringTypes.quarter:
            if (gameAllowTies) {
              hdrs1 = ['section', 'overall', 'team', 'w', 'l', 't', 'ow', 'ol', 'ot']
            } else {
              hdrs1 = ['section', 'overall', 'team', 'w', 'l', 'ow', 'ol']
            }
            break;
          case gameScoringTypes.half:
            hdrs1 = ['team', 'section', 'overall', 'w', 'l', 't', 'p', 'ow', 'ol', 'ot', 'op']
            break;
          case gameScoringTypes.inning:
            hdrs1 = ['team', 'section', 'overall', 'w', 'l', 'ow', 'ol']
            break;
          default:
            hdrs1 = ['team', 'section', 'overall', 'w', 'l', 't', 'p', 'ow', 'ol', 'ot', 'op']
        }
      }
    }
    return <div key={uniqueKey('ss', 'sh')} className={cn}>
      {hdrs1.map((hi, index) => {
        const _hi = hi.length === 2 ? hi.replace('o', '') : hi
        return <div key={uniqueKey('ss', 'sh', index)} className={'ss-' + hi}>{_.startCase(_hi)}</div>
      })}
    </div>
  }, [])

  return standingsHeader
}
